import type { TypedDocumentNode } from '@apollo/client';
import type { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
import type { Mutation, MutationDeleteOrderArgs, MutationSaveOrderTemplateArgs } from 'sr-types/lib/order/v1/graphql';
import { ReferenceFragment } from '../../../../common/list/fragments';
import { MUTATION_NAMES, ROOT_FIELDS } from './resourceOrdersConstants';

const createOrderMutation = (mutationName: string, rootField: string): DocumentNode => {
    return gql`
        mutation ${mutationName}(
            $resourceId: ID!
            $orderInput: OrderInput
            $workflowInput: WorkflowInput
            $noteInput: NoteInput
        ) {
            ${rootField}(
                resourceId: $resourceId
                orderInput: $orderInput
                workflowInput: $workflowInput
                noteInput: $noteInput
            ) {
                id
                errors {
                    field
                    key
                    message
                }
                reference {
                    ...Reference
                }
            }
        }
        ${ReferenceFragment}
    `;
};

const createDealMutation = (mutationName: string, rootField: string): DocumentNode => {
    return gql`
        mutation ${mutationName}(
            $orderInput: OrderInput
            $noteInput: NoteInput
        ) {
            ${rootField}(
                orderInput: $orderInput
                noteInput: $noteInput
            ) {
                id
                errors {
                    field
                    key
                    message
                }
                reference {
                    ...Reference
                }
            }
        }
        ${ReferenceFragment}
    `;
};

const createOrderTemplateMutation = (
    mutationName: string,
    rootField: string
): TypedDocumentNode<Pick<Mutation, 'saveOrderTemplate'>, MutationSaveOrderTemplateArgs> => {
    return gql`
        mutation ${mutationName}(
            $orderInput: OrderInput
        ) {
            ${rootField}(
                orderInput: $orderInput
            ) {
                id
                errors {
                    field
                    key
                    message
                }
                reference {
                    ...Reference
                }
            }
        }
        ${ReferenceFragment}
    `;
};

const createDeleteOrderTemplateMutation = (
    mutationName: string,
    rootField: string
): TypedDocumentNode<Pick<Mutation, 'deleteOrder'>, MutationDeleteOrderArgs> => {
    return gql`
        mutation ${mutationName}(
            $orderId: ID!
        ) {
            ${rootField}(
                orderId: $orderId
            ) {
                id
                errors {
                    field
                    key
                    message
                }
            }
        }
    `;
};

export const saveResourceQuote = createOrderMutation(MUTATION_NAMES.saveQuote, ROOT_FIELDS.saveQuote);
export const saveResourceOrder = createOrderMutation(MUTATION_NAMES.saveOrder, ROOT_FIELDS.saveOrder);
export const saveOrderTemplate = createOrderTemplateMutation(
    MUTATION_NAMES.saveOrderTemplate,
    ROOT_FIELDS.saveOrderTemplate
);
export const saveResourceDeal = createOrderMutation(MUTATION_NAMES.saveDeal, ROOT_FIELDS.saveDeal);
export const deleteOrderTemplate = createDeleteOrderTemplateMutation(
    MUTATION_NAMES.deleteOrderTemplate,
    ROOT_FIELDS.deleteOrder
);
export const confirmResourceOrder = createOrderMutation(MUTATION_NAMES.confirmOrder, ROOT_FIELDS.confirmOrder);
export const confirmResourceQuote = createOrderMutation(MUTATION_NAMES.confirmQuote, ROOT_FIELDS.confirmQuote);
export const confirmResourceDeal = createDealMutation(MUTATION_NAMES.confirmDeal, ROOT_FIELDS.confirmDeal);
